import React, { useContext } from "react"
import { BagItem } from "./BagItem"
import styled from "styled-components"

import { GlobalContext } from "../context/GlobalState"

export const BagItemList = () => {
  const { bagItems } = useContext(GlobalContext)

  return (
    <>
      <ItemList>
        {bagItems.length === 0 && <p>There's nothing here yet.</p>}

        {bagItems.map((bagItem, index) => (
          <BagItem key={index} bagItem={bagItem} />
        ))}
      </ItemList>
    </>
  )
}

const ItemList = styled.div`
  position: absolute;
  top: 10%;
  width: 100%;
  left: 2.5px;

  p {
    font-family: "lato", sans-serif;
    font-size: 1.1rem;
  }
`
